module.exports = __webpack_public_path__ + "img/selectequipment.66d8a41d.svg";